import { ISO_4217 } from "../../iso-4217";
import { event, GtagEvent } from "./event";
import { Item } from "./item";

export interface Purchase extends GtagEvent {
    currency:ISO_4217;
    value: number;
    transaction_id :string;
    coupon?:string;
    shipping?: number;
    tax?: number;
    items:Item[]
}
export const purchase = ($_:Purchase) => event('purchase',$_);